import { createApp } from 'vue'
import App from './App.vue'
import { createRouter, createWebHistory } from 'vue-router';
import Home from './views/HomePage.vue';
import Projects from './views/ProjectsPage.vue';
import About from './views/AboutPage.vue';
import Contact from './views/ContactPage.vue';
import ProjectDetails from './views/ProjectDetails.vue';
import AboutSite from './views/AboutSitePage.vue';

import './styles.css';

const routes = [
  { path: '/', component: Home },
  { path: '/projects', component: Projects },
  { path: '/about', component: About},
  { path: '/contact', component: Contact},
  { path: '/about-site', component: AboutSite},
  { path: '/projects/:referencement', component: ProjectDetails, props: true},
  { path: '/experiencing-girlhood.html', 
    beforeEnter: (to, from, next) => {
      window.location.href = '/experiencing-girlhood.html';
      next(false); 
    }
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition
    } else {
      return { x: 0, y: 0 }
    }
  }
});

createApp(App).use(router).mount('#app');
